import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { CounterBadge, CounterBadgePriority } from '.';
import { counterBadgeDriverFactory } from './CounterBadge.driver';

describe('CounterBadge', () => {
  const createDriver = createRendererWithUniDriver(counterBadgeDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<CounterBadge value={16} />);
    expect(await driver.exists()).toBe(true);
  });

  it('should render the right value in the getContent()', async () => {
    const { driver } = createDriver(<CounterBadge value={6} />);

    expect(await driver.getContent()).toBe('6');
  });

  it('should render +99 badge as default if value is above 99', async () => {
    const { driver } = createDriver(<CounterBadge value={134} />);

    expect(await driver.getContent()).toBe('+99');
  });

  it('should render +[maximum] if value is above maximum', async () => {
    const maximum = 9;
    const { driver } = createDriver(
      <CounterBadge maximum={maximum} value={maximum + 1} />,
    );

    expect(await driver.getContent()).toBe(`+${maximum}`);
  });

  [CounterBadgePriority.primary, CounterBadgePriority.secondary].forEach(
    (priority) => {
      it(`should render counter badge for priority = ${priority}`, async () => {
        const { driver } = createDriver(
          <CounterBadge priority={priority} value={8} />,
        );

        expect(await driver.exists()).toBe(true);
      });
    },
  );
});
